/** CoStar.Api.ConsumerUserData.ListingFraud.ReasonCodeEnum */
export var ReasonCodeEnum;
(function (ReasonCodeEnum) {
    ReasonCodeEnum[ReasonCodeEnum["None"] = 0] = "None";
    ReasonCodeEnum[ReasonCodeEnum["FraudScam"] = 1] = "FraudScam";
    ReasonCodeEnum[ReasonCodeEnum["PriceInaccurate"] = 2] = "PriceInaccurate";
    ReasonCodeEnum[ReasonCodeEnum["AvailabilityInaccurate"] = 3] = "AvailabilityInaccurate";
    ReasonCodeEnum[ReasonCodeEnum["LocationIncorrect"] = 4] = "LocationIncorrect";
    ReasonCodeEnum[ReasonCodeEnum["Other"] = 5] = "Other";
    ReasonCodeEnum[ReasonCodeEnum["NotAvailable"] = 6] = "NotAvailable";
    ReasonCodeEnum[ReasonCodeEnum["Video"] = 7] = "Video";
    ReasonCodeEnum[ReasonCodeEnum["FlaggedThirdPartyFeed"] = 8] = "FlaggedThirdPartyFeed";
})(ReasonCodeEnum || (ReasonCodeEnum = {}));
